import { Component, OnInit,ViewChild } from '@angular/core';
import { InvoiceService} from 'app/shared/services/invoice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';



@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {

  displayedColumns: string[] = ['invoiceNo', 'invoiceDate', 'customer', 'amount','paid','due','status','createdBy','action'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  filteredTypeList : any[]=[];

  isDark: boolean = false;

  invoices : any [] =[];
  backupList=[];
  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
    createReceipt:null,
   };


  constructor(
              private invoiceService : InvoiceService, 
              private router : Router, 
              private themeService: NbThemeService,
              private route : ActivatedRoute, 
              private authService: AuthService,
             ) { }

  ngOnInit() {

    this.getAllInvoices();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
    
  }

  getControlPermissions(){
    var data = [];
    var data2 = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='INV'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  
    data2 =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='RECEIPT'
    });
  
    if(data2.length > 0){
      this.crud_access.createReceipt = data2[0].create;

    }

  }

  convertToFloat(val: any): number {
    return parseFloat(val) || 0;
  }

    newButtonClick(){
    this.router.navigate(['../invoice'],{relativeTo : this.route});
    }


  getAllInvoices(){
    this.invoiceService.getAll()
     .subscribe(
        (data) => {
                    this.invoices = data.filter((el)=>{
                      return el.Type ==="Invoice";
                    });;
                    this.dataSource = new  MatTableDataSource (this.invoices);  
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;      
                   
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  

       
       
     }
   

     viewDetailsButtonClick(invoiceNo : string){   
          this.router.navigate(['../invoice'],{queryParams : {'invoiceNo':invoiceNo},relativeTo : this.route});       
     }

     payButtonClicked(invoiceNo){  
      this.router.navigate(['../receipt'],{queryParams : {'invoiceNo':invoiceNo},relativeTo : this.route});            
     }

     checkedChangeRdoButtons(event){
      if(event.value =="All"){
        this.dataSource = new  MatTableDataSource(this.invoices);
        this.dataSource.paginator = this.paginator; 
      }
      else if(event.value =="Paid"){
        this.filteredTypeList = this.invoices.filter((el)=>{
         return el.Status ===event.value;
       });  
       this.dataSource = new  MatTableDataSource (this.filteredTypeList);
       this.dataSource.paginator = this.paginator; 
      }
      else if(event.value =="Unpaid"){
       this.filteredTypeList = this.invoices.filter((el)=>{
         return el.Status ===event.value || el.Status==='Partially paid';
       });
       this.dataSource = new  MatTableDataSource (this.filteredTypeList);
       this.dataSource.paginator = this.paginator; 
     }
    }


   applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

   }
   onSearchClear(){
     this.searchKey = "";
     this.applyFilter();
   }


}
